export default "__VITE_ASSET__B3DLCJ0t__"